import { useSuspenseQuery } from '@tanstack/react-query';
import { getCharacterList } from '~/api';
import { GetCharacterTypeRequest, GetExploreCharacterData } from '~/types';
import { MINUTE } from '~/constants';
import characterKey from './characterKey';

const useGetListByCharacterTypeQuery = (
  request: Pick<GetCharacterTypeRequest, 'type'>,
) => {
  return useSuspenseQuery({
    queryKey: characterKey.getListByType(request),
    queryFn: () => getCharacterList(request),
    select: ({ data, status }) => {
      return data as GetExploreCharacterData[];
    },
    staleTime: 30 * MINUTE,
  });
};

export default useGetListByCharacterTypeQuery;
